module.exports = __webpack_public_path__ + "static/19-top-3-trends-shaping-the-future-of-work-760bd67c4a614807ca74ab082f600337.jpg";